import { getStytchJWT } from './getStytchJWT'

/**
 * Extract organization ID from Stytch session JWT cookie
 * @returns Organization ID from the session
 * @throws Error if not logged in or session expired
 */
export function getOrgId(): string {
  const decoded = getStytchJWT()

  if (!decoded) {
    throw new Error('Not logged in or session expired')
  }

  // Use internal_organization_id as it serves our specific purpose
  const organizationId = decoded.internal_organization_id

  if (!organizationId) {
    throw new Error('No organization ID found in session')
  }

  return organizationId
}
